

import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PageViewportLayout } from '../template';
import { FlexBox } from '@brg/ui';
import styled from 'styled-components';
import { LayoutConst } from 'core/modules';

const MainTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 70px;
    text-align: center;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.projectEdit.frame.mainTitle.color};

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 34px;
        line-height: 41px;
    }
`;

const Description = styled(FlexBox)`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
    text-align: center;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.projectEdit.frame.description.color};

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 13px;
        line-height: 16px;
        max-width: 290px;
    }
`;

const Link = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.projectEdit.frame.link.color};

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const ErrorNotPreviewPermission: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    const link = useMemo(() => window.location.href?.replace('preview', 'project') , []);

    return (
        <PageViewportLayout offsetTop={0} justify={'center'} align={'center'} style={{ height: '100%' }}>
            <MainTitle style={{ textAlign: "center"}}>
                {t('project_edit.frames.not_premission_preview')}
            </MainTitle>
            <Description offsetTop={36} offsetTopMobile={24} offsetBottom={16} offsetBottomMobile={8}>
                {t('project_edit.frames.permissions_watch_preview')}
            </Description>
            <Link style={{ marginBottom: '16px' }}>
                <a href={link}>{t('project_edit.link_to_project')}</a>
            </Link>
        </PageViewportLayout>
    );
};


import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PageViewportLayout } from '../template';
import { FlexBox } from '@brg/ui';
import styled from 'styled-components';
import { LayoutConst } from 'core/modules';

const MainTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 70px;
    text-align: center;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.projectEdit.frame.mainTitle.color};

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 34px;
        line-height: 41px;
    }
`;

const Description = styled(FlexBox)`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
    text-align: center;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.projectEdit.frame.description.color};

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 13px;
        line-height: 16px;
        max-width: 290px;
    }
`;

const Link = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.projectEdit.frame.link.color};

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const ErrorNotPreviewPermission: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    const link = useMemo(() => window.location.href?.replace('preview', 'project') , []);

    return (
        <PageViewportLayout offsetTop={0} justify={'center'} align={'center'} style={{ height: '100%' }}>
            <MainTitle style={{ textAlign: "center"}}>
                {t('project_edit.frames.not_premission_preview')}
            </MainTitle>
            <Description offsetTop={36} offsetTopMobile={24} offsetBottom={16} offsetBottomMobile={8}>
                {t('project_edit.frames.permissions_watch_preview')}
            </Description>
            <Link style={{ marginBottom: '16px' }}>
                <a href={link}>{t('project_edit.link_to_project')}</a>
            </Link>
        </PageViewportLayout>
    );
};
